import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@fly/core';
import { ISuggestion } from '@fly/shared';
import classNames from 'classnames';

import styles from '../../FlyChat.module.less';

interface FlyChatSuggestionsProps {
  items: Array<ISuggestion>;
  onSetMessage: (message: string) => void;
}
export const FlyChatSuggestions = ({
  items = [],
  onSetMessage,
}: FlyChatSuggestionsProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(styles.suggestionContainer, 'px-fly-1')}
      data-testid='chat-suggestions'
    >
      <h5 className='font-semibold p-fly-3 pb-fly-2 text-size-fly-2 opacity-64'>
        {t('app.dashboard.chat.footer.suggestions', {
          defaultValue: 'Suggestions',
        })}
      </h5>
      <ul className='flex flex-col gap-fly-1'>
        {items.map((item, index) => (
          <li key={index} className='' data-testid='chat-suggestion-item'>
            <Button
              color='neutral'
              variant='ghost'
              size='1'
              onClick={() => onSetMessage(item.content)}
              iconStart='arrow_top_right'
              className='!text-slate-12 w-full justify-start truncate'
            >
              <span className='block flex-1 truncate text-left'>
                {item.content}
              </span>
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
};
